import { render, staticRenderFns } from "./editSysDocumentView.vue?vue&type=template&id=23a4748a"
import script from "./editSysDocumentView.vue?vue&type=script&lang=js"
export * from "./editSysDocumentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports